/** Sort field for the integrations list. Maps to the `orderBy` URL param. */
export const INTEGRATION_SORT_FIELD = {
  name: "displayName",
  status: "isActive",
} as const;
